import { forEach } from 'lodash';

export default function handleRegex(regexes, text) {
  const replacedTexts = [];

  forEach(regexes, regex => {
    const pattern = new RegExp(regex.pattern);
    const newText = text.replace(pattern, regex.mask);

    if (newText !== text) {
      replacedTexts.push({
        text: newText,
        priority: regex.priority
      });
      return replacedTexts;
    }

    return null;
  });

  // no matching
  if (replacedTexts.length === 0) {
    return text;
  }

  // many matchings - sort by priority
  if (replacedTexts.length && replacedTexts.length > 0) {
    replacedTexts.sort((a, b) => b.priority - a.priority);
  }

  // one matching
  return handleRegex(regexes, replacedTexts[0].text);
}
